module.exports = __webpack_public_path__ + "73354a4e25dfea37a2612c5617aaa3cd.pdf";